import { Directive, ViewContainerRef, inject } from '@angular/core';

@Directive({
  selector: '[adminDocumentUploadDialogDirective]',
  standalone: false
})
export class DocumentUploadDialogDirective {
  viewContainerRef = inject(ViewContainerRef);
}
